// Create a new file: /components/workflow/Array2ElementNode.jsx

import React from 'react';
import { Handle, Position } from 'reactflow';
import { UnfoldVertical } from 'lucide-react';

const UnwrapArrayNode = ({ id, data }) => {
  const selectedArrayName =
    data.selectedArrayPath?.split('.').pop() || 'Not Configured';

  return (
    <div className="w-64 rounded-lg border-2 border-teal-700 bg-zinc-800 shadow-lg">
      <div className="flex items-center gap-3 rounded-t-lg border-b border-zinc-700 bg-zinc-900/50 p-3">
        <UnfoldVertical className="text-teal-400" size={20} />
        <h3 className="text-base font-bold text-white">Unwrap Array</h3> {id}
      </div>
      <div className="space-y-1 p-3 text-xs text-slate-300">
        <p className="truncate">
          <span className="font-semibold text-slate-400">Source: </span>
          {selectedArrayName}
        </p>
        <p>
          <span className="font-semibold text-slate-400">Output: </span>
          Single 'arrayElement'
        </p>
      </div>
      <Handle
        type="source"
        position={Position.Right}
        className="h-3 w-3 !bg-teal-500"
      />
      <Handle
        type="target"
        position={Position.Left}
        className="h-3 w-3 !bg-rose-500"
      />
    </div>
  );
};

export default UnwrapArrayNode;
